import { setEditMultipleChoiceQuestionManuallyModal } from '../../../../../store/workspace/slice';
import { MultipleChoiceQuestionDetail } from '../../../../../store/workspace/types';
import DropDown from '../../../../../components/DropDown';
import TextArea from '../../../../../components/TextArea';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import type * as monaco from 'monaco-editor';
import Editor from '@monaco-editor/react';
import styles from './style.module.scss';
import {
    useRef,
    Dispatch,
    useEffect,
    useState,
    SetStateAction,
} from 'react';
import {
    TrashIcon,
    XCloseIcon,
    WarningIcon,
    CheckSolidIcon,
    CodeCircleIcon,
    EditSquareIcon,
    TimesSolidIcon,
    TextAlignLeftIcon,
} from '../../../../../assets/icons';

const questionTypes = [
    { id: 2, title: 'general' },
    { id: 1, title: 'technical' },
    { id: 2, title: 'coding' },
]

const questionLevels = [
    { id: 1, title: 'easy' },
    { id: 2, title: 'medium' },
    { id: 3, title: 'hard' },
]

interface Props {
    selectedQuestion: MultipleChoiceQuestionDetail | null;
    setMultipleChoiceExamQuestions: Dispatch<SetStateAction<MultipleChoiceQuestionDetail[]>>;
}

export default function EditManually(props: Props) {
    const { selectedQuestion, setMultipleChoiceExamQuestions } = props;

    const dispatch = useDispatch();
    const [correctAnswer, setCorrectAnswer] = useState(selectedQuestion?.answer || 0);
    const [question, setQuestion] = useState(selectedQuestion?.question || '');
    const [option1, setOption1] = useState('');
    const [option2, setOption2] = useState('');
    const [option3, setOption3] = useState('');
    const [option4, setOption4] = useState('');

    const [option1CodeBlock, setOption1CodeBlock] = useState('');
    const [option2CodeBlock, setOption2CodeBlock] = useState('');
    const [option3CodeBlock, setOption3CodeBlock] = useState('');
    const [option4CodeBlock, setOption4CodeBlock] = useState('');

    const [questionCodeBlock, setQuestionCodeBlock] = useState('');
    const [isQuestionCodeBlock, setIsQuestionCodeBlock] = useState(false);

    const [isOption1CodeBlock, setIsOption1CodeBlock] = useState(false);
    const [isOption2CodeBlock, setIsOption2CodeBlock] = useState(false);
    const [isOption3CodeBlock, setIsOption3CodeBlock] = useState(false);
    const [isOption4CodeBlock, setIsOption4CodeBlock] = useState(false);

    const questionEditorRef = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);
    const editorRef1 = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);
    const editorRef2 = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);
    const editorRef3 = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);
    const editorRef4 = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);

    function handleQuestionEditorDidMount(editor: monaco.editor.IStandaloneCodeEditor, monacoInstance: typeof monaco) {
        questionEditorRef.current = editor;
    }

    function handleEditorDidMount1(editor: monaco.editor.IStandaloneCodeEditor, monacoInstance: typeof monaco) {
        editorRef1.current = editor;
    }

    function handleEditorDidMount2(editor: monaco.editor.IStandaloneCodeEditor, monacoInstance: typeof monaco) {
        editorRef2.current = editor;
    }

    function handleEditorDidMount3(editor: monaco.editor.IStandaloneCodeEditor, monacoInstance: typeof monaco) {
        editorRef3.current = editor;
    }

    function handleEditorDidMount4(editor: monaco.editor.IStandaloneCodeEditor, monacoInstance: typeof monaco) {
        editorRef4.current = editor;
    }

    function handleQuestionEditorChange(value: string | undefined) {
        setQuestionCodeBlock(value || '');
    }

    function handleEditorChange1(value: string | undefined) {
        setOption1CodeBlock(value || '');
    }

    function handleEditorChange2(value: string | undefined) {
        setOption2CodeBlock(value || '');
    }

    function handleEditorChange3(value: string | undefined) {
        setOption3CodeBlock(value || '');
    }

    function handleEditorChange4(value: string | undefined) {
        setOption4CodeBlock(value || '');
    }

    const [questionType, setQuestionType] = useState({
        id: selectedQuestion?.type || 1,
        title: selectedQuestion?.type || 'General'
    });

    const [questionLevel, setQuestionLevel] = useState({
        id: selectedQuestion?.level || 1,
        title: selectedQuestion?.level || 'Easy'
    });


    useEffect(() => {
        console.log(selectedQuestion?.choices[0].split('```'));

        setQuestion(selectedQuestion?.question.split('```')[0] || '');
        setQuestionCodeBlock(selectedQuestion?.question.split('```')[1] || '');
        setIsQuestionCodeBlock(selectedQuestion?.question.includes('```') || false);

        if (selectedQuestion?.choices[0].includes('```')) {
            setIsOption1CodeBlock(true);
            setOption1CodeBlock(selectedQuestion?.choices[0].split('```')[1] || '');
        } else {
            setOption1(selectedQuestion?.choices[0] || '');
        }

        if (selectedQuestion?.choices[1].includes('```')) {
            setIsOption2CodeBlock(true);
            setOption2CodeBlock(selectedQuestion?.choices[1].split('```')[1] || '');
        } else {
            setOption2(selectedQuestion?.choices[1] || '');
        }

        if (selectedQuestion?.choices[2].includes('```')) {
            setIsOption3CodeBlock(true);
            setOption3CodeBlock(selectedQuestion?.choices[2].split('```')[1] || '');
        } else {
            setOption3(selectedQuestion?.choices[2] || '');
        }

        if (selectedQuestion?.choices[3].includes('```')) {
            setIsOption4CodeBlock(true);
            setOption4CodeBlock(selectedQuestion?.choices[3].split('```')[1] || '');
        } else {
            setOption4(selectedQuestion?.choices[3] || '');
        }

    }, [selectedQuestion]);

    const handleSave = () => {
        // setSelectedQuestion(prev => prev ? {
        //     ...prev,
        //     answer: correctAnswer,
        //     question: question,
        //     choices: [option1, option2, option3, option4]
        // } : null);

        const qst = question + (isQuestionCodeBlock ? ('\n```' + questionCodeBlock + '```') : '');
        const opt1 = isOption1CodeBlock ? ('```' + option1CodeBlock + '```') : option1;
        const opt2 = isOption2CodeBlock ? ('```' + option2CodeBlock + '```') : option2;
        const opt3 = isOption3CodeBlock ? ('```' + option3CodeBlock + '```') : option3;
        const opt4 = isOption4CodeBlock ? ('```' + option4CodeBlock + '```') : option4;

        setMultipleChoiceExamQuestions(prev => prev.map(q => q === selectedQuestion ? {
            ...q,
            answer: correctAnswer,
            type: questionType.title,
            level: questionLevel.title,
            question: qst,
            choices: [opt1, opt2, opt3, opt4],
            isEdited: true
        } : q));

        dispatch(setEditMultipleChoiceQuestionManuallyModal(false));
    }

    return (
        <Modal
            size='xxl'
            title='Edit manually'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setEditMultipleChoiceQuestionManuallyModal(false))}
        >
            <div className={styles.warning}>
                <WarningIcon />
                <span>It is your responsibility to ask and answer the correct questions manually</span>
            </div>

            <div className={styles.question}>
                <div className={styles.question_section}>
                    <div className={styles.question_types}>
                        <DropDown
                            label='Question type'
                            setItem={setQuestionType}
                            idKey='id'
                            titleKey='title'
                            selectedItem={questionType}
                            dropDownList={questionTypes}
                            wrapperClassName={styles.question_types_dropdown}
                        />
                        <DropDown
                            label='Question level'
                            setItem={setQuestionLevel}
                            idKey='id'
                            titleKey='title'
                            selectedItem={questionLevel}
                            dropDownList={questionLevels}
                            wrapperClassName={styles.question_types_dropdown}
                        />
                    </div>
                    <TextArea
                        maxLength={200}
                        value={question}
                        onChange={setQuestion}
                        label='Edit question'
                        className={styles.question_textarea}
                    />
                    {!isQuestionCodeBlock && <span
                        className={styles.question_section_add_code_block}
                        onClick={() => setIsQuestionCodeBlock(!isQuestionCodeBlock)}
                    >
                        + Add code block
                    </span>}
                </div>
                {isQuestionCodeBlock &&
                    <div className={styles.question_editor}>
                        <div className={styles.question_editor_header}>
                            <span>Code block</span>
                            <div
                                className={styles.question_editor_header_remove}
                                onClick={() => setIsQuestionCodeBlock(false)}
                            >
                                <TrashIcon />
                                <span>Remove</span>
                            </div>
                        </div>
                        <Editor
                            theme='vs-dark'
                            defaultValue=""
                            value={questionCodeBlock}
                            onChange={handleQuestionEditorChange}
                            onMount={handleQuestionEditorDidMount}
                            className={styles.code_editor}
                            defaultLanguage="python"
                            height="235px"
                        />
                    </div>}
            </div>

            <div className={styles.options}>
                {/* Option 1 */}
                <div className={styles.option}>
                    <span className={styles.option_index}>1.</span>
                    <span className={styles.option_check} onClick={() => setCorrectAnswer(0)}>
                        {correctAnswer === 0 ? <CheckSolidIcon /> : <TimesSolidIcon />}
                    </span>
                    {isOption1CodeBlock ?
                        <Editor
                            theme='vs-dark'
                            defaultValue=""
                            value={option1CodeBlock}
                            onChange={handleEditorChange1}
                            onMount={handleEditorDidMount1}
                            className={styles.code_editor}
                            defaultLanguage="python"
                            height="100px"
                        /> : <div className={styles.option_input} data-has-error={option1 === ''}>
                            <input type="text" value={option1} onChange={(e) => setOption1(e.target.value)} />
                            <XCloseIcon stroke='#000000' onClick={() => setOption1('')} />
                        </div>}
                    <div
                        className={styles.option_switch}
                        onClick={() => setIsOption1CodeBlock(!isOption1CodeBlock)}
                    >
                        {isOption1CodeBlock ? <>
                            <TextAlignLeftIcon />
                            <span>Switch to text</span>
                        </> : <>
                            <CodeCircleIcon />
                            <span>Switch to code block</span>
                        </>}
                    </div>
                </div>

                {/* Option 2 */}
                <div className={styles.option}>
                    <span className={styles.option_index}>2.</span>
                    <span className={styles.option_check} onClick={() => setCorrectAnswer(1)}>
                        {correctAnswer === 1 ? <CheckSolidIcon /> : <TimesSolidIcon />}
                    </span>
                    {isOption2CodeBlock ?
                        <Editor
                            theme='vs-dark'
                            defaultValue=""
                            value={option2CodeBlock}
                            onChange={handleEditorChange2}
                            onMount={handleEditorDidMount2}
                            className={styles.code_editor}
                            defaultLanguage="python"
                            height="100px"
                        /> : <div className={styles.option_input} data-has-error={option2 === ''}>
                            <input type="text" value={option2} onChange={(e) => setOption2(e.target.value)} />
                            <XCloseIcon stroke='#000000' onClick={() => setOption2('')} />
                        </div>}
                    <div
                        className={styles.option_switch}
                        onClick={() => setIsOption2CodeBlock(!isOption2CodeBlock)}
                    >
                        {isOption2CodeBlock ? <>
                            <TextAlignLeftIcon />
                            <span>Switch to text</span>
                        </> : <>
                            <CodeCircleIcon />
                            <span>Switch to code block</span>
                        </>}
                    </div>
                </div>

                {/* Option 3 */}
                <div className={styles.option}>
                    <span className={styles.option_index}>3.</span>
                    <span className={styles.option_check} onClick={() => setCorrectAnswer(2)}>
                        {correctAnswer === 2 ? <CheckSolidIcon /> : <TimesSolidIcon />}
                    </span>
                    {isOption3CodeBlock ?
                        <Editor
                            theme='vs-dark'
                            defaultValue=""
                            value={option3CodeBlock}
                            onChange={handleEditorChange3}
                            onMount={handleEditorDidMount3}
                            className={styles.code_editor}
                            defaultLanguage="python"
                            height="100px"
                        /> : <div className={styles.option_input} data-has-error={option3 === ''}>
                            <input type="text" value={option3} onChange={(e) => setOption3(e.target.value)} />
                            <XCloseIcon stroke='#000000' onClick={() => setOption3('')} />
                        </div>}
                    <div
                        className={styles.option_switch}
                        onClick={() => setIsOption3CodeBlock(!isOption3CodeBlock)}
                    >
                        {isOption3CodeBlock ? <>
                            <TextAlignLeftIcon />
                            <span>Switch to text</span>
                        </> : <>
                            <CodeCircleIcon />
                            <span>Switch to code block</span>
                        </>}
                    </div>
                </div>

                {/* Option 4 */}
                <div className={styles.option}>
                    <span className={styles.option_index}>4.</span>
                    <span className={styles.option_check} onClick={() => setCorrectAnswer(3)}>
                        {correctAnswer === 3 ? <CheckSolidIcon /> : <TimesSolidIcon />}
                    </span>
                    {isOption4CodeBlock ?
                        <Editor
                            theme='vs-dark'
                            defaultValue=""
                            value={option4CodeBlock}
                            onChange={handleEditorChange4}
                            onMount={handleEditorDidMount4}
                            className={styles.code_editor}
                            defaultLanguage="python"
                            height="100px"
                        /> : <div className={styles.option_input} data-has-error={option4 === ''}>
                            <input type="text" value={option4} onChange={(e) => setOption4(e.target.value)} />
                            <XCloseIcon stroke='#000000' onClick={() => setOption4('')} />
                        </div>}
                    <div
                        className={styles.option_switch}
                        onClick={() => setIsOption4CodeBlock(!isOption4CodeBlock)}
                    >
                        {isOption4CodeBlock ? <>
                            <TextAlignLeftIcon />
                            <span>Switch to text</span>
                        </> : <>
                            <CodeCircleIcon />
                            <span>Switch to code block</span>
                        </>}
                    </div>
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setEditMultipleChoiceQuestionManuallyModal(false))}
                />
                <Button
                    type='Primary'
                    text='Save'
                    className={styles.actions_btn}
                    onClick={handleSave}
                />
            </div>
        </Modal>
    );
};